import { useStore } from "zustand";

import { collectStore } from "./store";
import { type CollectState } from "./store.types";
import {
  getCollectOrderLines,
  getCollectSuccessInfo,
  getCollectFlow,
  getStatusFilter,
  getSearchBy,
  getSelectedLetter,
  getGroupPrimary,
  getGroupSecondary
} from "./getters";

export function useOrderLinesToCollect(): CollectState["orderLines"] {
  return useStore(collectStore, getCollectOrderLines);
}

export function useCollectSuccessInfo(): CollectState["successInfo"] {
  return useStore(collectStore, getCollectSuccessInfo);
}

export function useCollectFlow(): CollectState["flow"] {
  return useStore(collectStore, getCollectFlow);
}

export function useCollectStatusFilter(): CollectState["statusFilter"] {
  return useStore(collectStore, getStatusFilter);
}

export function useCollectSearchBy(): CollectState["searchBy"] {
  return useStore(collectStore, getSearchBy);
}

export function useCollectSelectedLetter(): CollectState["selectedLetter"] {
  return useStore(collectStore, getSelectedLetter);
}

export function useCollectGroupPrimary(): CollectState["groupPrimary"] {
  return useStore(collectStore, getGroupPrimary);
}

export function useCollectGroupSecondary(): CollectState["groupSecondary"] {
  return useStore(collectStore, getGroupSecondary);
}
